import {useEffect, useState} from 'react'
import axios from 'axios'
import ApiRequest from 'EurestoApi/ApiRequest'
import project from 'EurestoConfig/project.config'

export default (path, requete, action, params, key) => {
  const [data, setData] = useState([])
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let unmounted = false
    let source = axios.CancelToken.source()
    ApiRequest(project.api + path, {
      ...params,
      requete: requete,
      action: action
    }, {
      showAlertError: false,
      cancelToken: source.token,
    }).then(result => {
      if (!unmounted) {
        setData(result.results)
        setLoading(false)
      }
    }).catch(function (e) {
      if (!unmounted) {
        setError(true)
        setErrorMessage(e.message)
        setLoading(false)
        if (axios.isCancel(e)) {
          console.log(`request cancelled:${e.message}`)
        } else {
          console.log('another error happened:' + e.message)
        }
      }
    })
    return function () {
      unmounted = true
      source.cancel('Cancelling in cleanup')
    }
  }, [key])

  return { data, loading, error, errorMessage }
};



// WEBPACK FOOTER //
// ./app/Utilitaire/Hook/useAxiosCancelToken/index.js